import React from 'react';

import PrintDocumentButton from '../../../components/print-document-button';

import {
  labelQuePrintLabelStart,
  labelQuePrintOrderSummary,
  labelQuePrintPackingSlipStart,
  labelQuePrintPickListStart,
  labelQuePrintShipmentManifestStart,
} from '../../../store/label-que/label-que.actions';
import { DocumentType } from '../../../enums/document-type';
import { GenericPrintDocumentMenuItem } from './generic-print-menu-item';
import { usePicklistsFeatureGate } from '../../../feature-gates/use-picklists-feature-gate';

export const LabelQueuePrintDocumentButton = (props) => {
  const { isFeatureEnabled: isPickListFeatureEnabled } = usePicklistsFeatureGate();
  return (
    <PrintDocumentButton {...props} theme='tertiary'>
      <GenericPrintDocumentMenuItem action={labelQuePrintPackingSlipStart} name={DocumentType.PackingSlip.documentNameTranslation} />
      <GenericPrintDocumentMenuItem action={labelQuePrintLabelStart} name={DocumentType.Label.documentNameTranslation} />
      <GenericPrintDocumentMenuItem
        action={labelQuePrintPickListStart}
        disabled={!isPickListFeatureEnabled}
        isFeatureEnabled={isPickListFeatureEnabled}
        name={DocumentType.PickList.documentNameTranslation}
      />
      <GenericPrintDocumentMenuItem
        action={labelQuePrintShipmentManifestStart}
        name={DocumentType.ShipmentManifest.documentNameTranslation}
      />
      <GenericPrintDocumentMenuItem action={labelQuePrintOrderSummary} name={DocumentType.OrderSummary.documentNameTranslation} />
    </PrintDocumentButton>
  );
};
